// Terminal-style loading spinner component
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  message?: string;
  isOpen: boolean;
}

const SPINNER_CHARS = '⠸⠰⠠⠤⠦⠧⠇⠏⠟⠻⠹⠼⠿⠾⠼';

export function LoadingSpinner({ message = 'Loading...', isOpen }: LoadingSpinnerProps) {
  if (!isOpen) return null;

  return (
    <div className="loading-overlay fade-in">
      <div className="loading-content">
        <p className="loading-message">{message}</p>
        <div className="loading-spinner">
          <div className="spinner-track">
            <span className="spinner-chars">{SPINNER_CHARS}</span>
            <span className="spinner-chars">{SPINNER_CHARS}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
